
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
import { Select2Module } from 'ng2-select2';
import { CampaignComponent } from './campaign.component';
import { DetailComponent } from './detail.component';
import { ListComponent } from './list.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';



@NgModule({
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        GrowlModule,
        TooltipModule,
        BrowserModule,
        HelperModule,
        CardModule,
        PaginationModule,
        ToastrModule.forRoot(),
        Select2Module,
        BsDatepickerModule.forRoot()
    ],

    declarations: [
        CampaignComponent,
        DetailComponent,
        ListComponent
    ],
    exports: [CampaignComponent],
    entryComponents: [],
    providers: []
})

export class CampaignModule {
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/campaign/campaign.module.ts